import { createRequestActionTypes } from "../../shared/utility";

export const IssuerActions = {
    fetchIssuerDetailsForIssuer: createRequestActionTypes('FETCH_ISSUER_DETAILS_FOR_ISSUER'),
    fetchCountryDetailsForIssuer: createRequestActionTypes('FETCH_COUNTRY_DETAILS_FOR_ISSUER'),
    createAndEditIssuer: createRequestActionTypes('CREATE_AND_EDIT_ISSUER'),
    uploadDocumentForIssuer: createRequestActionTypes('UPLOAD_DOCUMENT_FOR_ISSUER'),
    fetchInterestTypes: createRequestActionTypes('FETCH_INTEREST_TYPES'),
}